<script setup lang="ts">
import { IconDownload, IconFile } from '#shared'
import { computed } from 'vue'
import type { FileAttachment } from '../model/attachment'

const { attachment } = defineProps<{ attachment: FileAttachment }>()

const fullAttachmentUrl = computed(() => import.meta.env.VITE_BASE_API_URL + attachment.url)
</script>

<template>
  <li :class="$style.root">
    <a :class="$style.content" :href="fullAttachmentUrl" download>
      <IconFile />
      <div :class="$style.fileName">
        {{ attachment.name }}
      </div>
      <IconDownload :class="$style.download" />
    </a>
  </li>
</template>

<style lang="scss" module>
.content {
  display: flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
  max-width: 100%;

  &:not(:hover) {
    .download {
      opacity: 0;
    }
  }
}

.fileName {
  min-width: 0;
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download {
  width: 15px;
  height: 15px;
  transition: opacity 0.1s;
}
</style>
